import axios from 'axios'
import React, { useState } from 'react'
import { ProductCard } from './ProductCard'

const ProductSelection = ({
  eventName,
  userId,
  token,
  url,
  malaysian,
  purchasedPhysical,
  physical,
  purchasedPreCongressWorkshop,
  preCongressWorkshop,
  preCongressWorkshopDisc,
  sst,
  gp,
  purchasedGpOrders,
  eligibleGp,
}) => {
  const [selected, setSelected] = useState(null)
  const [selectedWorkshop, setSelectedWorkshop] = useState(null)
  const [selectedGp, setSelectedGp] = useState(null)

  const productIds = [selected, selectedWorkshop, selectedGp]

  const preCongressWorkshopProducts = () => {
    if (purchasedPhysical || selected) {
      return preCongressWorkshopDisc
    } else {
      return preCongressWorkshop
    }
  }

  const disabled = () => {
    return productIds.every((id) => id === null)
  }

  const handlePhysicalSelection = (physicalId) => {
    // If selecting a physical product for the first time or changing selection,
    // reset the workshop selection since available options will change
    if (!selected || selected !== physicalId) {
      setSelectedWorkshop(null)
    }
    setSelected(physicalId)
  }

  return (
    <div id="productSelection">
      <form action={url} method="POST">
        <input type="hidden" name="authenticity_token" value={token} />
        <input type="hidden" name="product_ids" value={productIds} />

        <h3 className="text-navy text-center">Select Conference Ticket</h3>

        <ProductCard
          cardTitle={eventName}
          products={physical}
          selectedState={selected}
          setSelectedState={handlePhysicalSelection}
          activated={!purchasedPhysical}
          handleCheckbox={(e) => {
            if (!e.target.checked) {
              setSelected(null)
              setSelectedWorkshop(null)
            }
          }}
          handleRadio={() => {}}
        />

        <h3 className="text-navy text-center mt-4">
          Select Pre-Congress Workshop
        </h3>

        <ProductCard
          cardTitle="MSN Pre-Congress Workshop Registration"
          cardNote={
            !purchasedPhysical && !selected
              ? 'Register for the ISS MSN 2025 main congress to unlock special rates!'
              : ''
          }
          products={preCongressWorkshopProducts()}
          selectedState={selectedWorkshop}
          setSelectedState={setSelectedWorkshop}
          activated={!purchasedPreCongressWorkshop}
          handleCheckbox={(e) => {
            if (!e.target.checked) {
              setSelectedWorkshop(null)
            }
          }}
          handleRadio={() => {}}
        />

        {eligibleGp && (
          <>
            <h3 className="text-navy text-center mt-4">
              Select General Practitioner Track
            </h3>

            <ProductCard
              cardTitle="General Practitioner Track Registration"
              products={gp}
              selectedState={selectedGp}
              setSelectedState={setSelectedGp}
              activated={!purchasedGpOrders}
              handleCheckbox={(e) => {
                if (!e.target.checked) {
                  setSelectedGp(null)
                }
              }}
              handleRadio={() => {}}
            />
          </>
        )}

        {sst && (
          <strong className="d-block mx-auto">
            All purchases will incur 8% SST
          </strong>
        )}

        <button
          type="submit"
          className="btn text-white btn-primary d-block mx-auto mt-4"
          disabled={disabled()}
        >
          Purchase Pass
        </button>
      </form>
    </div>
  )
}

export default ProductSelection
